export const FETCH_ORDER = 'src/Order/FETCH_ORDER';
export const FETCH_ORDERS = 'src/Order/FETCH_ORDERS';
export const FETCH_ORDER_GROUPS = 'src/Order/FETCH_ORDER_GROUPS';
export const FETCH_EVENT_ORDERS = 'src/Order/FETCH_EVENT_ORDERS';
export const SET_IS_LOADING = 'src/Order/SET_IS_LOADING';
export const FETCH_USER_ORDERS = 'src/Order/FETCH_USER_ORDERS';
export const SET_DELETE_ORDER = 'src/Order/SET_DELETE_ORDER';
export const SET_SECOND_DISCOUNT = 'src/Order/SET_SECOND_DISCOUNT';
export const UPDATE_ORDER_PRODUCT_STATUS = 'src/Order/UPDATE_ORDER_PRODUCT_STATUS';
